import React from 'react';

const Container = ({ children }) => {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center m-0">
        <div className="col-12 col-md-11 col-xl-10 border py-3">{children}</div>
      </div>
    </div>
  );
};

export default Container;
